import { z } from "zod";
import { defineEvent } from "./registry.js";
/**
 * Onay motoru olayları. Yükler KİŞİSEL VERİ TAŞIMAZ (ad, başlık, açıklama yok): kiracıdaki tüm oturumlara
 * gidebilirler; istemci ayrıntıyı yetki denetimli `/approval-requests/:id` ucundan çeker.
 */
export const approvalRequestCreatedV1 = defineEvent({
    type: "approvals.request.created",
    version: 1,
    description: "Bir belge için onay talebi açıldı (politika yoksa doğrudan otomatik onaylandı)",
    realtime: ["tenant"],
    payload: z.object({
        requestId: z.uuid(),
        docType: z.string(),
        docId: z.uuid(),
        docNo: z.string().nullable(),
        companyId: z.uuid(),
        stationId: z.uuid().nullable(),
        amount: z.string().nullable().describe("Kuruş (dizge); tutarsız belgede null"),
        status: z.enum(["PENDING", "AUTO_APPROVED"]),
        policyId: z.uuid().nullable(),
        stepCount: z.number().int(),
    }),
});
export const approvalRequestDecidedV1 = defineEvent({
    type: "approvals.request.decided",
    version: 1,
    description: "Onay talebi sonuçlandı: onaylandı, reddedildi ya da geri çekildi",
    realtime: ["tenant"],
    payload: z.object({
        requestId: z.uuid(),
        docType: z.string(),
        docId: z.uuid(),
        companyId: z.uuid(),
        stationId: z.uuid().nullable(),
        outcome: z.enum(["APPROVED", "REJECTED", "CANCELLED"]),
        /** Sistem kararında (zaman aşımıyla otomatik red) null. */
        decidedBy: z.uuid().nullable(),
        stepNo: z.number().int().nullable(),
    }),
});
/** ALARM: adımın süresi doldu, karar üst onaycıya yükseltildi (adım başına BİR kez). */
export const approvalRequestEscalatedV1 = defineEvent({
    type: "approvals.request.escalated",
    version: 1,
    description: "Onay adımının süresi doldu; karar üst onaycıya yükseltildi",
    realtime: ["tenant"],
    payload: z.object({
        requestId: z.uuid(),
        docType: z.string(),
        docId: z.uuid(),
        companyId: z.uuid(),
        stationId: z.uuid().nullable(),
        stepNo: z.number().int(),
        /** Yükseltmeden sonra adımın yeni son karar zamanı. */
        dueAt: z.iso.datetime({ offset: true }).nullable(),
    }),
});
//# sourceMappingURL=approvals.v1.js.map